import { ManagePeopleApptsConsentPage } from './manage-people-appts-consent.page';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ManagePeopleApptsConsentPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagePeopleApptsConsentPageRoutingModule {}
